
































































import Vue from 'vue'

import {
  IItemReference,
  ILinkedItemForListing,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'LinkTasksDrawer',

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    currentlyLinkedTasks: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },
    originatingConversation: {
      type: Object as () => IItemReference,
      default: null,
    },
    originatingTask: {
      type: Object as () => IItemReference,
      default: null,
    },
    originatingItemEventId: {
      type: Number,
      default: null,
    },
    // Default project to select after projects dropdown is loaded
    defaultProjectId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      closeDrawerOnOutsideClick: true,
      drawerOpened: false,
      showAddTaskPanel: true,
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '100%'
      }
      return '680px'
    },
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
    },

    handleTaskCreated(createAnother: boolean) {
      this.$emit('task-created')
      if (!createAnother) {
        this.handleCancel()
      }
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },
  },
})
